import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { trackEvent } from "@/hooks/useBusinessData";

export default function VoyageFeature({ config }) {
  return (
    <section
      className="relative bg-white text-black py-24 md:py-36 overflow-hidden"
      data-testid="voyage-feature-section"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10 items-center">
          <div className="col-span-12 md:col-span-5">
            <div className="font-mono uppercase tracking-[0.28em] text-[10px] text-zinc-500 mb-6">
              § As featured in
            </div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="font-serif italic text-6xl md:text-8xl leading-[0.85] tracking-tight"
            >
              Voyage
              <br />
              ATL
            </motion.div>
            <div className="mt-6 h-px w-24 bg-black" />
          </div>

          <div className="col-span-12 md:col-span-7 md:pl-10">
            <motion.h3
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.1 }}
              className="font-serif text-3xl md:text-5xl leading-tight tracking-tight"
            >
              Exploring Life &amp; Business with Yolanda Campbell of SheCuts Barber Studio.
            </motion.h3>
            <p className="mt-6 text-zinc-600 text-base md:text-lg leading-relaxed max-w-xl">
              Read the full interview on Yolanda's journey — from Long Island salons and clipper mastery with Dudley's, to reopening She Cuts in Midtown Atlanta with faith, perseverance, and a clientele that followed her home.
            </p>

            <a
              href={config.voyageatl_url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent("voyage_clicked", {})}
              data-testid="voyage-read-more"
              className="mt-8 inline-flex items-center gap-3 group"
            >
              <span className="font-mono uppercase tracking-[0.22em] text-xs">
                Read the full feature
              </span>
              <span className="w-10 h-10 rounded-full bg-black text-white flex items-center justify-center transition-transform group-hover:rotate-45">
                <ArrowUpRight className="w-4 h-4" strokeWidth={1.4} />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
